import styled from '../../config/theme';

const TableWrapper = styled.div`
  display: block;
  overflow: auto;
`;

export default TableWrapper;
